import { List } from "@refinedev/mui";
import { DataGrid } from "@mui/x-data-grid";
import { useBranchDependentDataGrid } from "../../utils/hooks/useBranchDependentDataGrid";
import { Member } from "../../types/member";
import { memberCols } from "../../tables/memberCols";
import { useBranch } from "../../provider/BranchProvider";
import { Grid, Typography } from "@mui/material";
import MemberFilter from "./MemberFilter";
import { exposesPersonalData } from "../../types/branch";
import { useCustomTranslation } from "../../provider/useCustomTranslation";

export default function MemberList() {
  const branch = useBranch();
  const { dataGridProps, filters, setFilters } =
    useBranchDependentDataGrid<Member>({});
  const { t } = useCustomTranslation();
  if (!branch) return null;
  return (
    <List>
      <Typography variant={"subtitle1"} sx={{ mb: 2, mt: -3 }}>
        {t("pages.members.list.subtitle")}
      </Typography>
      <Grid item>
        <MemberFilter setFilters={setFilters} filters={filters} />
      </Grid>
      <DataGrid
        {...dataGridProps}
        getRowHeight={() => "auto"}
        columns={memberCols({
          branch,
          coin: branch?.coin,
          personalData: exposesPersonalData(branch),
          t,
        })}
        autoHeight
      />
    </List>
  );
}
